<template>
  <div class="container-fluid my-5 px-5">
    <div class="row">
      <div class="col-12">
        <h1>Integridade do Mês</h1>
        <p class="text-end">
          👉🏻👉🏻👉🏻 <router-link to="/roteirospublic">Exibição de roteiros</router-link> <br><br>
        </p>
      </div>
      <div class="col-12">
        <label for="dataselec" class="mb-3">Selecione a data para avaliar, ativar ou desativar, editar roteiros:</label>
        <input id="dataselec" type="date" :min="today" v-model="selectedDate" />
      </div>
      <div class="col-12">
        <button class="btn btn-secondary my-4" @click="fetchData3">Verificar integridade do mês</button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div v-for="(group, date) in groupedItems" :key="date">
          <h3 class="my-3">{{ date }}</h3>
          <div v-for="(timeGroup, time) in group" :key="time">
            <h4 class="my-2">{{ time }}</h4>
            <div class="grid-rotas">
              <div v-for="item in timeGroup" :key="item.codigo"
                :class="{ 'verde-ativo': item.ativo === '1', 'vermelho-inativo': item.ativo === '0' }">
                <p>{{ formatPosicao(item.codigo) }}</p>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';

export default {
  setup() {
    const today = new Date().toISOString().split('T')[0];
    const selectedDate = ref(today);
    const items = ref([]);
    const groupedItems = ref({});

    const formatDateToDDMMYYYY = (date) => {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    };

    const fetchData3 = async () => {
      const formattedDate = formatDateToDDMMYYYY(selectedDate.value);
      try {
        const response = await axios.get("https://museucatavento.org.br/sistema-agendamento/apiroteirosmes.php", {
          params: { datedisplay: formattedDate }
        });
        items.value = response.data.map(item => ({
          ...item,
          ativo: item.ativo.toString(), // Garantir que o valor de ativo seja uma string
          expandido: false
        }));
        groupItemsByDateAndTime();
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    const groupItemsByDateAndTime = () => {
      groupedItems.value = items.value.reduce((acc, item) => {
        const [day, month, year] = item.datedisplay.split('/');
        const date = `${day}/${month}/${year}`;
        const time = formatHorario(item.codigo);
        if (!acc[date]) {
          acc[date] = {};
        }
        if (!acc[date][time]) {
          acc[date][time] = [];
        }
        acc[date][time].push(item);
        return acc;
      }, {});
    };

    const formatHorario = (codigo) => {
      const hora = codigo.substring(8, 10);
      const minutos = codigo.substring(10, 12);
      return `${hora}:${minutos}`;
    };

    const formatPosicao = (codigo) => {
      const posicao = codigo.substring(14, 16);
      return posicao;
    };

    return {
      today,
      selectedDate,
      items,
      groupedItems,
      fetchData3,
      formatHorario,
      formatPosicao,
    };
  }
};
</script>

<style scoped>
tr {
  vertical-align: middle;
}

td {
  width: 16%;
  text-align: center;
}

th {
  text-align: center;
  padding-right: 20px;
}

input,
select,
textarea {
  width: 100%;
}

button {
  padding: 5px 10px;
  margin-top: 10px;
  cursor: pointer;
}

span {
  margin-left: 10px;
}

tr.inativo>td,
.inativo {
  background-color: #e2979d9e !important;
  /* Exemplo de cor para itens inativos */
}

.btn-ativo {
  background-color: #007bff;
  color: white;
}

.btn-inativo {
  background-color: #5a6268;
  color: white;
}

.locus-posicao {
  background-color: #00800045;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid black;
  transition: all 0.3s ease;
}

.locus-posicao>div:nth-child(n+2) {
  display: none;
}

.locus-posicao.expandido {
  width: 100%;
  display: flex;
  gap: 30px;
  flex-direction: row;
}

.locus-posicao.expandido>div:nth-child(n+2) {
  display: block;
}

.grid-rotas {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(20, 1fr);
  grid-row-gap: 20px;
}


.verde-ativo{
  background-color: greenyellow;
  display: flex;
  flex-direction: column;
  border: 1px black solid;
  padding: 5px;
}
.vermelho-inativo{
  background-color: palevioletred;
  display: flex;
  flex-direction: column;
  border: 1px black solid;
  padding: 5px;
}
</style>
